import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_REPORT_PROJECTS_SUCCESS, GetReportProjectsAction } from './reports.actions';

@Injectable()
export class ReportsResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve() {
    this.store.dispatch(new GetReportProjectsAction());
    return this.action$.ofType(GET_REPORT_PROJECTS_SUCCESS).take(1);
  }
}
